export { getAllStatusTranslate, getSentStatus, getRefundStatus, getReplacStatus, getProcessStatus, getCheckStatus, getSupply_statuses } from './OrderItemsStatuses'

export const splitToChunks=async(array, chunkSize)=> {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
}